angular
  .module('pis-common.module', []);
